module.exports = __webpack_public_path__ + "img/step1.ed95e53f.png";